export const ALLOWED_FILE_EXTENSIONS = [
  '.pdf',
  '.csv',
  '.tsv',
  '.xlsx',
  '.xls',
  '.xml',
  '.ods',
  '.ppt',
  '.pptx',
  '.odp',
  '.png',
  '.jpeg',
  '.jpg',
  '.svg',
  '.doc',
  '.docx',
  '.rtf',
  '.txt',
  '.odt',
  '.zip',
  '.gzip',
  '.mp4',
  '.mp3',
  '.wav',
  '.ogg',
  '.css',
  '.msg',
  '.eml',
  '.emltpl',
  '.kzn',
  '.m4a',
  '.aac',
  '.oga',
];
export const IMPORT_FILE_EXTENSIONS = ['.csv'];
export const IMAGE_FILE_EXTENSIONS = ['.png', '.jpeg', '.jpg', '.svg'];
export const AUDIO_FILE_EXTENSIONS = [
  '.mp3',
  '.wav',
  '.ogg',
  '.m4a',
  '.aac',
  '.oga',
];
